/**
 * Helpers for zero Admin Fee registration on PaymentScreen.
 * Fee amount must come from the API — never hardcode prices here.
 */

export function isExactZeroFee(price) {
  // Number(null) === 0 in JS — treat null/undefined/blank as not zero.
  if (price === null || price === undefined || price === "") {
    return false;
  }

  const amount = Number(price);
  return Number.isFinite(amount) && amount === 0;
}

export function formatAdminFeeDisplay(adminfee) {
  if (!adminfee) {
    return "Loading...";
  }

  const symbol = adminfee.currency_symbol || "";
  const amount = Number(adminfee.price);

  if (isExactZeroFee(adminfee.price)) {
    const formatted = Number.isFinite(amount) ? amount.toFixed(2) : "0.00";
    return `${symbol} ${formatted}`.trim();
  }

  return `${symbol} ${adminfee.price}`.trim();
}

/**
 * Resolve the authenticated user's id and plaintext JWT from existing portal storage.
 * Plaintext JWT is stored as localStorage "jwtToken" at registration/login.
 * currentUser.jwt is the same plaintext returned by the backend on auth success.
 */
export function resolveAuthCredentials(parsedUserData, jwtTokenFromStorage) {
  const userId = parsedUserData?.id || parsedUserData?._id || null;
  const jwt =
    (typeof jwtTokenFromStorage === "string" && jwtTokenFromStorage) ||
    (typeof parsedUserData?.jwt === "string" && parsedUserData.jwt) ||
    null;

  return { userId, jwt };
}

export function buildZeroFeeCompletionPayload(parsedUserData, jwtTokenFromStorage) {
  const { userId, jwt } = resolveAuthCredentials(
    parsedUserData,
    jwtTokenFromStorage
  );

  if (!userId || !jwt) {
    return null;
  }

  return {
    user_id: userId,
    jwt,
  };
}
